export const wordTypeMap = {
    noun: "名",
    verb: "动",
    pronoun: "代",
};
